import React, { useState } from "react";
import "moment/locale/pt-br.js";
import Table from "./table";
import ReportAcordeon from "../../../Components/ReportAcordeon";
import {
  getConsolidatedEvaluation,
  getDownloadReport,
  postDownloadReport,
  getMenuData,
} from "../../../../../services/NexiDigitalAPI";
import Filtro from "../ReactionEvaluation/Filtro"

const ConsolidatedReactionEvaluationReport = ({ index, expanded: _expanded }) => {
  const idReport = 13;
  const idCompany = getMenuData().idCompany;
  const name = "Relatório Consolidado de Avaliação de Reação";
  const description = (
    <div>
      <div>Este relatório traz dados consolidados de avaliações de reação.</div>
      <strong>IMPORTANTE:</strong> Para este relatório foram consideradas apenas as questões de
      escala.
    </div>
  );

  const [expanded, setExpanded] = useState(_expanded);
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [requestFilters, setRequestFilters] = useState({});

  const onClickExpanded = (value) => {
    setExpanded(value);
  };

  const actionFilter = async (values) => {
    if (expanded) {
      setLoading(true);

      const filter = { ...requestFilters, ...values };
      setRequestFilters(filter);


      getConsolidatedEvaluation({ ...filter, evaluationType: "REACTION" })
        .then((response) => {
          const responseData = response.data;

          setTotalRecords(responseData.totalRecords);
          setDados(responseData.result);
        })
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    }

  };

  const downloadEvent = async (filter) => {
    if (loading) {
      return;
    }

    setLoading(true);

    const filterBase = { ...requestFilters, ...filter };
    const { idEvaluation, idTeam, nodeCode } = filterBase;

    await postDownloadReport(idReport, { idEvaluation, idCompany, idTeam, nodeCode });
    await requestDownloadReport();
  };

  const requestDownloadReport = async () => {
    try {
      const response = await getDownloadReport(idReport);
      const { status, fileUrl } = response?.data || {};
      if (status === "Error") {
        setLoading(false);
        return;
      }
      if (status === "Waiting") {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return requestDownloadReport();
      }

      if (status === "Done" && fileUrl) {
        getFileReport(fileUrl);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getFileReport = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.click();
  };

  const filter = (
    <Filtro
      actionFilter={actionFilter}
      loading={loading}
      expanded={expanded}
      downloadEvent={downloadEvent}
    />
  );

  const result = (
    <Table data={dados} loading={loading} actionFilter={actionFilter} totalRecords={totalRecords} />
  );

  return (
    <ReportAcordeon
      onClickExpanded={onClickExpanded}
      name={name}
      description={description}
      filter={filter}
      result={result}
      index={index}
      expanded={expanded}
    />
  );
};

export default ConsolidatedReactionEvaluationReport;
